import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';

const NotFound = () => {
  const navigate = useNavigate();

  const quickLinks = [
    { label: 'Property Analysis', path: '/dashboard', icon: 'BarChart3' },
    { label: 'Search Properties', path: '/search-results', icon: 'Search' },
    { label: 'Professional Marketplace', path: '/professional-marketplace', icon: 'Users' },
    { label: 'Help Center', path: '/help', icon: 'HelpCircle' },
  ];

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Nav */}
      <nav className="border-b border-border px-4 md:px-8 h-16 flex items-center">
        <Link to="/" className="flex items-center gap-3">
          <img
            src="/assets/images/logo_LL-1772022913346.jpeg"
            alt="ListingLens logo"
            className="h-9 w-auto rounded-lg object-cover"
            style={{ boxShadow: '0 0 12px rgba(0,212,255,0.4)', border: '1px solid rgba(0,212,255,0.3)', maxWidth: '130px' }}
          />
        </Link>
      </nav>
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
        {/* 404 Visual */}
        <div className="relative mb-8">
          <h1 className="text-8xl md:text-9xl font-black text-primary/10 select-none">404</h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 bg-primary/10 rounded-2xl flex items-center justify-center">
              <Icon name="MapPinOff" size={40} color="var(--color-primary)" />
            </div>
          </div>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
          This Property Doesn't Exist
        </h2>
        <p className="text-muted-foreground max-w-md mb-8 leading-relaxed">
          Looks like this page has gone off-market. Let's get you back to finding your perfect property.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 mb-12">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-6 py-3 border border-border text-foreground rounded-xl font-medium hover:bg-card transition-colors"
          >
            <Icon name="ArrowLeft" size={18} />
            Go Back
          </button>
          <Link
            to="/"
            className="flex items-center justify-center gap-2 px-6 py-3 bg-primary text-primary-foreground rounded-xl font-medium hover:bg-primary/90 transition-colors"
          >
            <Icon name="Home" size={18} />
            Back to Home
          </Link>
        </div>

        {/* Quick Links */}
        <div className="w-full max-w-lg">
          <p className="text-sm text-muted-foreground mb-4">Or explore these popular sections:</p>
          <div className="grid grid-cols-2 gap-3">
            {quickLinks?.map((link) => (
              <Link
                key={link?.path}
                to={link?.path}
                className="flex items-center gap-3 p-4 bg-card border border-border rounded-xl hover:border-primary/40 transition-all group"
              >
                <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={link?.icon} size={16} color="var(--color-primary)" />
                </div>
                <span className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">{link?.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
